export default __webpack_public_path__ + "assets/img/btm-next-post.png";